// import React, { forwardRef, useImperativeHandle } from 'react';
// // import Application from '../pdf/Application.pdf';
// // import Application from '../pdf/ApplicationForm.pdf'
// import Application from '../pdf/Application.pdf'
// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import icon from '../All/images/tick-icon.png';
// import fontkit from '@pdf-lib/fontkit';
// import TimesRoman from '../fonts/times.ttf'
// import TimesRomanBold from '../fonts/TimesBold.ttf'
// import TimesRomanItalic from '../fonts/FontsFree-Net-times-new-roman-italic.ttf'
// import TimesRomanitalicBold from '../fonts/Times-New-Romance-Bold-Italic.ttf'
// import { toast, ToastContainer } from 'react-toastify';
// import { removeBracketedText } from '../Axiosinstance';

// const ApplicationForm = forwardRef((dataProp, ref) => {

//     const handleDownload = async (studentdetails) => {
//         console.log("studentdetails", studentdetails)
//         try {
//             const pdfBytes = await fetch(Application).then(res => res.arrayBuffer());
//             const pdfDoc = await PDFDocument.load(pdfBytes);

//             let image;
//             const imageUrl = studentdetails?.profileUrl || '';
//             // const imageUrl = 'https://res.cloudinary.com/dyjwwi8ea/raw/upload/v1722238090/LMS/courses/pexels-mikebirdy-188777.jpg';
//             // const imageResponse = await fetch(imageUrl);
//             // const imageBytes = await imageResponse.arrayBuffer();


//             if (imageUrl) {
//                 // Fetch and embed the image
//                 const imageResponse = await fetch(imageUrl);
//                 const imageBytes = await imageResponse.arrayBuffer();

//                 if (imageUrl.endsWith('.png')) {
//                     image = await pdfDoc.embedPng(imageBytes);
//                 } else if (imageUrl.endsWith('.jpg') || imageUrl.endsWith('.jpeg')) {
//                     image = await pdfDoc.embedJpg(imageBytes);
//                 } else {
//                     throw new Error("Unsupported image format. Only PNG and JPG are supported.");
//                 }
//             }
//             // Get the fifth page
//             const pagess = pdfDoc.getPages();
//             const fifthPages = pagess[0]; // Index is 0-based
//             // Draw the image on the fifth page
//             if (image) {
//                 const { width, height } = fifthPages.getSize();
//                 fifthPages.drawImage(image, {
//                     x: 438, // Adjust as needed
//                     y: 561, // Adjust as needed
//                     width: 118, // Adjust as needed
//                     height: 130, // Adjust as needed
//                 });
//             }


//             // Access the pages
//             const pages = pdfDoc.getPages();
//             const firstPage = pages[0];
//             const secondPage = pages[1];
//             const thirdPage = pages[2];
//             const fourthPage = pages[3];
//             const fivthPage = pages[4];
//             const sixthPage = pages[6];
//             const seventhPage = pages[7];
//             const eightPage = pages[8];
//             const ninthPage = pages[13];
//             const fouteenPage = pages[14];
//             const fivteenPage = pages[15];
//             const lastPage = pages[18];
//             pdfDoc.registerFontkit(fontkit);

//             // Set font and size
//             const calibriFontBoldBytes = await fetch(TimesRoman).then((res) => res.arrayBuffer());
//             const font = await pdfDoc.embedFont(calibriFontBoldBytes);

//             const calibriFontBold = await fetch(TimesRomanBold).then((res) => res.arrayBuffer());
//             const fontBold = await pdfDoc.embedFont(calibriFontBold);

//             const calibriFontitalic = await fetch(TimesRomanItalic).then((res) => res.arrayBuffer());
//             const fontitalic = await pdfDoc.embedFont(calibriFontitalic);

//             const calibriFontitalicBold = await fetch(TimesRomanitalicBold).then((res) => res.arrayBuffer());
//             const fontitalicBold = await pdfDoc.embedFont(calibriFontitalicBold);

//             const fontSize = 9;



//             // Data to insert
//             const studentName = (studentdetails?.name || '').toUpperCase();
//             const passportNo = studentdetails?.passport || '';
//             const passportexpire = studentdetails?.passportExpiryDate || '';
//             const nric = studentdetails?.nric || '';
//             const handphone = studentdetails?.phone || '';
//             const officephone = studentdetails?.officephone || '';
//             const email = studentdetails?.email || '';
//             const dob = studentdetails?.dob || '';
//             const citizenship = (studentdetails?.citizenship || '').toUpperCase();
//             const maritalStatus = (studentdetails?.maritalStatus || '').toUpperCase();
//             const religion = (studentdetails?.religion || '').toUpperCase();
//             const gender = (studentdetails?.gender || '').toUpperCase();
//             const postalcode = studentdetails?.postalcode || '';
//             const courseFee = studentdetails?.batch?.courseFee || '';
//             const duration = studentdetails?.batch?.duration || '';
//             const courseType = studentdetails?.batch?.courseType || '';
//             const emergencyContacts = studentdetails?.emergencyContacts || [];
//             const signDate = studentdetails?.signDate || '';
//             const singapore = (studentdetails?.currentAddress || '').toUpperCase();
//             const address = (studentdetails?.address || '').toUpperCase();
//             const studentIds = (studentdetails?.studentIds || '');
//             const commencementDate = (studentdetails?.commencementDate || '');
//             const completeDate = (studentdetails?.completeDate || '');
//             const workExpirences = studentdetails?.workExpirences || '';
//             const description = studentdetails?.batch?.description || '';

//             function formatDatepassport(dateString) {
//                 const [year, month, day] = dateString.split('-');

//                 const date = new Date(`${year}-${month}-${day}`);
//                 const dayStr = String(date.getDate()).padStart(2, '0');
//                 const monthStr = date.toLocaleString('en-US', { month: 'long' }); // e.g., "May"
//                 const yearStr = date.getFullYear();

//                 return `${dayStr} ${monthStr} ${yearStr}`;
//             }

//             const course = removeBracketedText((studentdetails?.course || '')).toUpperCase();

//             const institutionDetails = studentdetails?.institutionDetails || [];

//             // Draw existing text on different pages
//             firstPage.drawText(studentName, { x: 185, y: 487, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(passportNo, { x: 175, y: 468, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(formatDatepassport(passportexpire), { x: 440, y: 468, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(nric, { x: 188, y: 449, size: 11, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(formatDatepassport(dob), { x: 440, y: 446, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(religion, { x: 189, y: 404, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(handphone, { x: 190, y: 384, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(officephone, { x: 439, y: 384, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(email, { x: 185, y: 360, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(citizenship, { x: 439, y: 404, size: 12, font, color: rgb(0, 0, 0), });
//             function wraptext(text, font, size, maxwidth) {
//                 const words = text.split(' ');
//                 const lines = [];
//                 let currentLine = '';

//                 for (const word of words) {
//                     const width = font.widthOfTextAtSize(currentLine + ' ' + word, size);
//                     if (width <= maxwidth) {
//                         currentLine += (currentLine ? ' ' : '') + word;
//                     } else {
//                         if (currentLine) lines.push(currentLine);
//                         currentLine = word;
//                     }
//                 }
//                 if (currentLine) lines.push(currentLine);

//                 return lines;
//             }
//             const maxwidth = 260;
//             const fontsize = 12;

//             let y = 605;

//             const lines = wraptext(course, font, fontsize, maxwidth);
//             for (const line of lines) {
//                 firstPage.drawText(line, { x: 175, y, size: fontsize, font, color: rgb(0, 0, 0) });
//                 y -= fontsize; // Adjust line spacing if needed
//             }
//             firstPage.drawText(`${courseFee} $`, { x: 322, y: 576, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(`${duration} Months`, { x: 174, y: 576, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(gender, { x: 189, y: 427, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(maritalStatus, { x: 439, y: 426, size: 12, font, color: rgb(0, 0, 0), });
//             firstPage.drawText(postalcode, { x: 204, y: 318, size: 12, font, color: rgb(0, 0, 0), });


//             // Strikethrough the one not selected
//             if (courseType !== 'Full time') {
//                 firstPage.drawLine({
//                     start: { x: 164, y: 552 },
//                     end: { x: 212, y: 552 },
//                     thickness: 1,
//                     color: rgb(0, 0, 0),
//                 });
//             }

//             if (courseType !== 'Part time') {
//                 firstPage.drawLine({
//                     start: { x: 221, y: 552 },
//                     end: { x: 267, y: 552 },
//                     thickness: 1,
//                     color: rgb(0, 0, 0),
//                 });
//             }

//             // emereceny
//             const usedLabels = new Set();

//             // 2. Collect used labels properly
//             emergencyContacts.forEach(contact => {
//                 const relationship = contact.relationship?.toLowerCase();

//                 if (relationship === 'others') {
//                     // Add special label to prevent strike
//                     usedLabels.add('othersname');
//                 } else {
//                     usedLabels.add(relationship); // Add 'brother', 'sister', etc.
//                 }
//             });

//             // 3. Draw emergency contact details
//             emergencyContacts.forEach(contact => {
//                 const { name, number, relationship, othersRelationship } = contact;
//                 const fontSize = 12;

//                 if (relationship === 'Brother') {
//                     firstPage.drawText(`${name}`, { x: 179, y: 232, size: fontSize, font, color: rgb(0, 0, 0) });
//                     firstPage.drawText(`${number}`, { x: 419, y: 232, size: fontSize, font, color: rgb(0, 0, 0) });

//                 } else if (relationship === 'Sister') {
//                     firstPage.drawText(`${name}`, { x: 179, y: 232, size: fontSize, font, color: rgb(0, 0, 0) });
//                     firstPage.drawText(`${number}`, { x: 419, y: 232, size: fontSize, font, color: rgb(0, 0, 0) });

//                 } else if (relationship === 'Mother') {
//                     firstPage.drawText(`${name}`, { x: 179, y: 251, size: fontSize, font, color: rgb(0, 0, 0) });
//                     firstPage.drawText(`${number}`, { x: 419, y: 251, size: fontSize, font, color: rgb(0, 0, 0) });

//                 } else if (relationship === 'Father') {
//                     firstPage.drawText(`${name}`, { x: 179, y: 252, size: fontSize, font, color: rgb(0, 0, 0) });
//                     firstPage.drawText(`${number}`, { x: 419, y: 252, size: fontSize, font, color: rgb(0, 0, 0) });

//                 } else if (relationship === 'Others') {
//                     firstPage.drawText(`${name}`, { x: 180, y: 212, size: fontSize, font, color: rgb(0, 0, 0) });
//                     firstPage.drawText(`${number}`, { x: 420, y: 212, size: fontSize, font, color: rgb(0, 0, 0) });
//                     firstPage.drawText(`${othersRelationship}`, { x: 300, y: 196, size: fontSize, font, color: rgb(0, 0, 0) });
//                 }
//             });

//             // 4. Strike only unused labels
//             const strikeLabel = (label, x, y) => {
//                 const width = font.widthOfTextAtSize(label, fontSize);
//                 firstPage.drawLine({
//                     start: { x, y: y + 6 },
//                     end: { x: x + width, y: y + 6 },
//                     thickness: 1,
//                     color: rgb(0, 0, 0),
//                 });
//             };

//             // 5. Label positions
//             const labelPositions = [
//                 { label: 'brother', x: 58, y: 233 },
//                 { label: 'sister', x: 92, y: 233 },
//                 { label: 'mother', x: 93, y: 254 },
//                 { label: 'father', x: 56, y: 254 },
//                 { label: 'othersname', x: 57, y: 213 }
//             ];

//             // 6. Only strike if not used
//             labelPositions.forEach(({ label, x, y }) => {
//                 if (!usedLabels.has(label)) {
//                     strikeLabel(label.charAt(0).toUpperCase() + label.slice(1), x, y);
//                 }
//             });



//             //FOR LAST page
//             const drawWrappedText = (page, text, xFirst, y, maxWidthFirst, xSubsequent, maxWidthSubsequent, font, fontSize, color) => {
//                 const lines = [];
//                 let currentLine = '';
//                 let words = text.split(' ');

//                 while (words.length > 0) {
//                     let word = words.shift();
//                     let testLine = currentLine + word + ' ';
//                     let testWidth = font.widthOfTextAtSize(testLine, fontSize);

//                     if (testWidth <= (lines.length === 0 ? maxWidthFirst : maxWidthSubsequent)) {
//                         currentLine = testLine;
//                     } else {
//                         lines.push(currentLine.trim());
//                         currentLine = word + ' ';
//                     }
//                 }
//                 lines.push(currentLine.trim());

//                 // Draw lines
//                 lines.forEach((line, index) => {
//                     page.drawText(line, {
//                         x: index === 0 ? xFirst : xSubsequent,
//                         y: y - (index * fontSize * 3),
//                         size: fontSize,
//                         font: font,
//                         color: color
//                     });
//                 });
//             };

//             drawWrappedText(firstPage, address, 187, 337, 300, 77, 410, font, 11, rgb(0, 0, 0));
//             // drawWrappedText(firstPage, singapore, 190, 249, 330, 77, 410, font, 11, rgb(0, 0, 0));



//             const maxWith = 480;
//             const lineHeigh = 12;
//             const xStart = 53;
//             let yStart = 345;

//             const Text = `I, ${studentName} declare that all information given by me in this registration form are true and correct and I understand that any misinterpretation or omission of information is sufficient grounds for rejecting my application. I also authorize any investigation of the above information for the purpose of verification. While I am a Student, I undertake to observe all the statues, By-Laws and Rules of the School. I agree to pay the full course fees for one year.`;

//             // Function to wrap and justify text, underline student name
//             function drawJustifiedTextWithUnderline(page, text, name, x, y, maxWith, font, fontSize, lineHeigh) {
//                 const words = text.split(' ');
//                 let lines = [];
//                 let currentLine = '';

//                 for (let word of words) {
//                     const testLine = currentLine ? `${currentLine} ${word}` : word;
//                     const width = font.widthOfTextAtSize(testLine, fontSize);
//                     if (width > maxWith) {
//                         lines.push(currentLine);
//                         currentLine = word;
//                     } else {
//                         currentLine = testLine;
//                     }
//                 }
//                 if (currentLine) lines.push(currentLine);

//                 lines.forEach((line, idx) => {
//                     const isLastLine = idx === lines.length - 1;
//                     const lineWords = line.trim().split(' ');

//                     if (isLastLine || lineWords.length === 1) {
//                         // Left-align last line
//                         page.drawText(line, {
//                             x,
//                             y,
//                             size: fontSize,
//                             font,
//                             color: rgb(0, 0, 0),
//                         });
//                     } else {
//                         // Justify
//                         const textWithoutSpaces = lineWords.join('');
//                         const totalTextWidth = font.widthOfTextAtSize(textWithoutSpaces, fontSize);
//                         const spaceWidth = (maxWith - totalTextWidth) / (lineWords.length - 1);
//                         let currentX = x;

//                         const fullLine = lineWords.join(' ');
//                         if (idx === 0 && fullLine.includes(name)) {
//                             const beforeName = fullLine.slice(0, fullLine.indexOf(name));
//                             const underlineX = x + font.widthOfTextAtSize(beforeName, fontSize);
//                             const underlineWidth = font.widthOfTextAtSize(name, fontSize);

//                             // Draw underline
//                             page.drawLine({
//                                 start: { x: underlineX, y: y - 1 },
//                                 end: { x: underlineX + underlineWidth, y: y - 1 },
//                                 thickness: 0.5,
//                                 color: rgb(0, 0, 0),
//                             });
//                         }

//                         // Draw each word with spacing
//                         lineWords.forEach((word, i) => {
//                             page.drawText(word, {
//                                 x: currentX,
//                                 y,
//                                 size: fontSize,
//                                 font,
//                                 color: rgb(0, 0, 0),
//                             });
//                             currentX += font.widthOfTextAtSize(word, fontSize);
//                             if (i < lineWords.length - 1) currentX += spaceWidth;
//                         });
//                     }

//                     y -= lineHeigh;
//                 });
//             }
//             // Call the function
//             drawJustifiedTextWithUnderline(
//                 secondPage,
//                 Text,
//                 studentName,
//                 xStart,
//                 yStart,
//                 maxWith,
//                 font,
//                 fontSize,
//                 lineHeigh
//             );

//             secondPage.drawText(formatDatepassport(signDate), { x: 460, y: 268, size: 9, font, color: rgb(0, 0, 0), });
//             secondPage.drawText(formatDatepassport(signDate), { x: 494, y: 96, size: 9, font, color: rgb(0, 0, 0), });




//             const underlineY = 440;

//             // Parts of the sentence
//             const sentencePrefix = "I, ";

//             const middleText = "  of  ";


//             // Measure each part
//             const prefixWidth = font.widthOfTextAtSize(sentencePrefix, 13);
//             const nameWidth = font.widthOfTextAtSize(studentName, 13);
//             const middleWidth = font.widthOfTextAtSize(middleText, 13);
//             const nricWidth = font.widthOfTextAtSize(nric, 13);

//             // Total width of full sentence
//             const fullLineWidth = prefixWidth + nameWidth + middleWidth + nricWidth;

//             // Get page width and compute centered X position
//             const pageWidth = thirdPage.getWidth();
//             const centeredX = (pageWidth - fullLineWidth) / 2;

//             // X positions of each segment
//             const nameX = centeredX + prefixWidth;
//             const middleX = nameX + nameWidth;
//             const nricX = middleX + middleWidth;

//             // Draw "I, "
//             thirdPage.drawText(sentencePrefix, {
//                 x: centeredX,
//                 y: underlineY,
//                 size: 13,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             // Draw name
//             thirdPage.drawText(studentName, {
//                 x: nameX,
//                 y: underlineY,
//                 size: 13,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             // Underline name
//             thirdPage.drawLine({
//                 start: { x: nameX, y: underlineY - 1.5 },
//                 end: { x: nameX + nameWidth, y: underlineY - 1.5 },
//                 thickness: 1,
//                 color: rgb(0, 0, 0),
//             });

//             // Draw " of "
//             thirdPage.drawText(middleText, {
//                 x: middleX,
//                 y: underlineY,
//                 size: 13,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             // Draw NRIC
//             thirdPage.drawText(nric, {
//                 x: nricX,
//                 y: underlineY,
//                 size: 13,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             // Underline NRIC
//             thirdPage.drawLine({
//                 start: { x: nricX, y: underlineY - 1.5 },
//                 end: { x: nricX + nricWidth, y: underlineY - 1.5 },
//                 thickness: 1,
//                 color: rgb(0, 0, 0),
//             });

//             thirdPage.drawText(formatDatepassport(signDate), { x: 424, y: 223, size: 11, font, color: rgb(0, 0, 0), });

//             fourthPage.drawText(studentName, { x: 50, y: 593, size: 10, font, color: rgb(0, 0, 0), });
//             fourthPage.drawText(nric, { x: 50, y: 545, size: 10, font, color: rgb(0, 0, 0), });
//             fourthPage.drawText(handphone, { x: 334, y: 545, size: 10, font, color: rgb(0, 0, 0), });
//             fourthPage.drawText(course, { x: 127, y: 524, size: 10, font, color: rgb(0, 0, 0), });
//             fourthPage.drawText(`${duration} Months`, { x: 121, y: 500, size: 10, font, color: rgb(0, 0, 0), });

//             fivthPage.drawText(formatDatepassport(signDate), { x: 180, y: 203, size: 11, font, color: rgb(0, 0, 0), });
//             fivthPage.drawText(formatDatepassport(signDate), { x: 398, y: 203, size: 11, font, color: rgb(0, 0, 0), });
//             fivthPage.drawText(formatDatepassport(signDate), { x: 75, y: 132, size: 11, font, color: rgb(0, 0, 0), });

//             // Main sentence
//             const sentenceStart = 'I ';
//             const sentenceMiddle = ', NRIC/Passport number ';


//             // Font sizes and Y positions
//             const fontSizee = 12;
//             const labelFontSize = 10;
//             const textY = 692;
//             const labelY = textY - 12; // Label below the line

//             // Measure widths
//             const studentNameWidth = font.widthOfTextAtSize(studentName, fontSizee);
//             const nricwidth = font.widthOfTextAtSize(nric, fontSizee);
//             const centerX = 50;
//             const middleeX = centerX + font.widthOfTextAtSize(sentenceStart, fontSizee) + studentNameWidth;
//             const nriccX = middleeX + font.widthOfTextAtSize(sentenceMiddle, fontSizee);

//             // Draw sentence text
//             sixthPage.drawText(sentenceStart, { x: centerX, y: textY, size: fontSizee, font });
//             sixthPage.drawText(studentName, { x: centerX + font.widthOfTextAtSize(sentenceStart, fontSizee), y: textY, size: fontSizee, font });
//             sixthPage.drawText(sentenceMiddle, { x: middleeX, y: textY, size: fontSizee, font });
//             sixthPage.drawText(nric, { x: nriccX, y: textY, size: fontSizee, font });


//             // Underline studentName
//             sixthPage.drawLine({
//                 start: { x: centerX + font.widthOfTextAtSize(sentenceStart, fontSizee), y: textY - 2 },
//                 end: { x: centerX + font.widthOfTextAtSize(sentenceStart, fontSizee) + studentNameWidth, y: textY - 2 },
//                 thickness: 0.5,
//                 color: rgb(0, 0, 0),
//             });

//             // Underline NRIC
//             sixthPage.drawLine({
//                 start: { x: nriccX, y: textY - 2 },
//                 end: { x: nriccX + nricwidth, y: textY - 2 },
//                 thickness: 0.5,
//                 color: rgb(0, 0, 0),
//             });

//             // Labels below
//             sixthPage.drawText('(name of student/parent/guardian)', {
//                 x: centerX + font.widthOfTextAtSize(sentenceStart, fontSizee),
//                 y: labelY,
//                 size: labelFontSize,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             sixthPage.drawText('(NRIC/passport no.)', {
//                 x: nriccX,
//                 y: labelY,
//                 size: labelFontSize,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             sixthPage.drawText(formatDatepassport(signDate), { x: 420, y: 480, size: 12, font, color: rgb(0, 0, 0), });
//             sixthPage.drawText('-NA-', { x: 200, y: 624, size: 12, font, color: rgb(0, 0, 0), });
//             sixthPage.drawText('-NA-', { x: 372, y: 624, size: 12, font, color: rgb(0, 0, 0), });

//             //  seventhPage
//             seventhPage.drawText(formatDatepassport(signDate), { x: 80, y: 712, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(studentName, { x: 80, y: 701, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(address, { x: 80, y: 692, size: 9, font, color: rgb(0, 0, 0), });

//             seventhPage.drawText(nric, { x: 320, y: 591, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(studentName, { x: 320, y: 614, size: 9, font, color: rgb(0, 0, 0), });
//             function splitTextIntoLines(text, font, size, maxWidth, maxLines) {
//                 const words = text.split(' ');
//                 const lines = [];
//                 let currentLine = '';

//                 for (let word of words) {
//                     const testLine = currentLine ? currentLine + ' ' + word : word;
//                     const testWidth = font.widthOfTextAtSize(testLine, size);

//                     if (testWidth <= maxWidth) {
//                         currentLine = testLine;
//                     } else {
//                         lines.push(currentLine);
//                         currentLine = word;
//                         if (lines.length === maxLines - 1) break;
//                     }
//                 }
//                 if (lines.length < maxLines) {
//                     const finalLine = currentLine;
//                     let textToAdd = finalLine;
//                     while (font.widthOfTextAtSize(textToAdd + '...', size) > maxWidth && textToAdd.length > 0) {
//                         textToAdd = textToAdd.slice(0, -1);
//                     }
//                     lines.push(textToAdd + (textToAdd !== finalLine ? '...' : ''));
//                 }

//                 return lines;
//             }
//             const courses = course
//             const courseLines = splitTextIntoLines(courses, font, 9, 200, 2);
//             seventhPage.drawText(courseLines[0], { x: 320, y: 520, size: 9, font, color: rgb(0, 0, 0) });
//             if (courseLines[1]) {
//                 seventhPage.drawText(courseLines[1], { x: 320, y: 510, size: 9, font, color: rgb(0, 0, 0) }); // Line height 12
//             }
//             seventhPage.drawText(studentIds, { x: 320, y: 567, size: 9, font, color: rgb(0, 0, 0), });

//             seventhPage.drawText(formatDatepassport(dob), { x: 320, y: 544, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(courseType, { x: 320, y: 416, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(`S$${courseFee}`, { x: 320, y: 392, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(formatDatepassport(commencementDate), { x: 320, y: 346, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText(formatDatepassport(completeDate), { x: 320, y: 322, size: 9, font, color: rgb(0, 0, 0), });
//             function numberToWords(num) {
//                 const ones = [
//                     '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
//                     'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
//                     'Seventeen', 'Eighteen', 'Nineteen'
//                 ];
//                 const tens = [
//                     '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
//                 ];

//                 if (num === 0) return 'Zero';
//                 if (num < 20) return ones[num];
//                 if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '');
//                 if (num < 1000) {
//                     return ones[Math.floor(num / 100)] + ' Hundred' +
//                         (num % 100 === 0 ? '' : ' and ' + numberToWords(num % 100));
//                 }
//                 return num.toString();
//             }
//             const durationInWords = numberToWords(duration);
//             seventhPage.drawText(`${durationInWords} equal payments interest-free installments`, { x: 320, y: 370, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText('-NA', { x: 320, y: 486, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText('-NA', { x: 320, y: 440, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText('-NA', { x: 320, y: 266, size: 9, font, color: rgb(0, 0, 0), });
//             seventhPage.drawText('Newton International College', { x: 320, y: 463, size: 9, font, color: rgb(0, 0, 0), });

//             const fullText = 'Newton International College, 134 Jurong Gateway Road, #04- 307C Singapore 600134';
//             const maxWidth = 220;
//             // Function to split into two lines
//             function splitIntoTwoLines(text, font, fontSize, maxWidth) {
//                 const words = text.split(' ');
//                 let line1 = '';
//                 let line2 = '';

//                 for (let word of words) {
//                     const testLine = line1 + (line1 ? ' ' : '') + word;
//                     const width = font.widthOfTextAtSize(testLine, fontSize);
//                     if (width <= maxWidth) {
//                         line1 = testLine;
//                     } else {
//                         line2 += (line2 ? ' ' : '') + word;
//                     }
//                 }
//                 return [line1, line2];
//             }
//             const [line1, line2] = splitIntoTwoLines(fullText, font, fontSize, maxWidth);
//             seventhPage.drawText(line1, {
//                 x: 320,
//                 y: 298,
//                 size: fontSize,
//                 font,
//                 color: rgb(0, 0, 0),
//             });
//             seventhPage.drawText(line2, {
//                 x: 320,
//                 y: 288, // adjust downward for second line
//                 size: fontSize,
//                 font,
//                 color: rgb(0, 0, 0),
//             });

//             seventhPage.drawText(formatDatepassport(signDate), { x: 400, y: 179, size: 11, font, color: rgb(0, 0, 0), });

//             const centedX = 427;

//             // Measure actual width of studentName at the current font size
//             const namewidth = font.widthOfTextAtSize(studentName, 9);

//             // Calculate the true X starting point to center the text
//             const namX = centedX - namewidth / 2;

//             // Draw the name
//             seventhPage.drawText(studentName, {
//                 x: namX,
//                 y: 133,
//                 size: 9,
//                 font,
//                 color: rgb(0, 0, 0),
//             });


//             //eightpage


//             eightPage.drawText(nric, { x: 333, y: 515, size: 10, font, color: rgb(0, 0, 0), });
//             eightPage.drawText(studentName, { x: 333, y: 555, size: 10, font, color: rgb(0, 0, 0), });


//             //ninthpage

//             ninthPage.drawText(`${duration}`, { x: 303, y: 678, size: 9, font, color: rgb(0, 0, 0), });
//             const linee = splitTextIntoLine(course, font, fontSize, maxWidth);
//             let cnny = 710; // starting Y position
//             const lineeight = 10;
//             // adjust line height as needed

//             linee.forEach(liness => {
//                 ninthPage.drawText(liness, {
//                     x: 303,
//                     y: cnny,
//                     size: 9,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });
//                 cnny -= lineeight;
//             });

//             // ninthPage.drawText(course, { x: 303, y: 705, size: 9, font, color: rgb(0, 0, 0), });
//             ninthPage.drawText(formatDatepassport(commencementDate), { x: 303, y: 625, size: 9, font, color: rgb(0, 0, 0), });
//             ninthPage.drawText(formatDatepassport(completeDate), { x: 303, y: 597, size: 9, font, color: rgb(0, 0, 0), });
//             ninthPage.drawText(courseType, { x: 303, y: 651, size: 9, font, color: rgb(0, 0, 0), });
//             function splitTextIntoLine(text, font, fontSize, maxWidth) {
//                 const words = text.split(' ');
//                 const lines = [];
//                 let currentLine = '';

//                 for (let word of words) {
//                     const testLine = currentLine ? currentLine + ' ' + word : word;
//                     const testWidth = font.widthOfTextAtSize(testLine, fontSize);

//                     if (testWidth <= maxWidth) {
//                         currentLine = testLine;
//                     } else {
//                         lines.push(currentLine);
//                         currentLine = word;
//                     }
//                 }

//                 if (currentLine) lines.push(currentLine);

//                 return lines;
//             }
//             const lineees = splitTextIntoLine(course, font, fontSize, maxWidth);

//             let cny = 534; // starting Y position
//             // adjust line height as needed

//             lineees.forEach(liness => {
//                 ninthPage.drawText(liness, {
//                     x: 303,
//                     y: cny,
//                     size: 9,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });
//                 cny -= lineeight;
//             });

//             function wrapParagraph(text, maxWidth, font, baseFontSize) {
//                 const words = text.split(' ');
//                 const lines = [];
//                 let currentLine = '';


//                 for (const word of words) {
//                     const testLine = currentLine ? `${currentLine} ${word}` : word;
//                     const testWidth = font.widthOfTextAtSize(testLine, baseFontSize);

//                     if (testWidth > maxWidth) {
//                         if (currentLine) lines.push(currentLine); // push current line
//                         currentLine = word;

//                     } else {
//                         currentLine = testLine;
//                     }
//                 }

//                 if (currentLine) lines.push(currentLine); // push last line
//                 return lines;
//             }

//             function getAllTags(el) {
//                 const tags = new Set();
//                 while (el) {
//                     if (el.nodeName) tags.add(el.nodeName.toLowerCase());
//                     el = el.parentElement;
//                 }
//                 return tags;
//             }


//             function parseHTMLToStyledLines(html, fonts, maxWidth, baseFontSize) {
//                 const wrapper = document.createElement('div');
//                 wrapper.innerHTML = html;
//                 const lines = [];

//                 const addTextBlock = (text, tagSet, isListItem, listIndex, href = null) => {
//                     const clean = text.trim();
//                     if (!clean) return;

//                     let usedFont = fonts.fonte;
//                     let underline = false;
//                     let fontSize = baseFontSize;
//                     let bullet = '';
//                     let color = rgb(0, 0, 0);
//                     const indentOffset = isListItem ? 10 : 0;

//                     const isBold = tagSet.has('b') || tagSet.has('strong');
//                     const isItalic = tagSet.has('i') || tagSet.has('em');
//                     const isUnderline = tagSet.has('u');
//                     const isLink = tagSet.has('a');

//                     if (isBold && isItalic && fonts.fontitalicBolds) usedFont = fonts.fontitalicBolds;
//                     else if (isBold && fonts.fontBold) usedFont = fonts.fontBold;
//                     else if (isItalic && fonts.fontitalics) usedFont = fonts.fontitalics;

//                     if (isUnderline || isLink) underline = true;
//                     if (isLink) color = rgb(0, 0, 1); // blue for links

//                     if (tagSet.has('h1')) fontSize = 18;
//                     else if (tagSet.has('h2')) fontSize = 16;
//                     else if (tagSet.has('h3')) fontSize = 14;
//                     else if (tagSet.has('h4')) fontSize = 13;
//                     else if (tagSet.has('h5')) fontSize = 11;
//                     else if (tagSet.has('h6')) fontSize = 10;

//                     if (isListItem !== null) {
//                         bullet = isListItem === 'ol' ? `${listIndex + 1}. ` : '• ';
//                     }

//                     const wrapped = wrapParagraph(bullet + clean, maxWidth, usedFont, fontSize, indentOffset);
//                     wrapped.forEach((line, idx) =>
//                         lines.push({
//                             text: idx === 0 ? line : ' '.repeat(bullet.length) + line,
//                             font: usedFont,
//                             fontSize,
//                             underline,
//                             color,
//                             link: href,
//                         })
//                     );
//                 };

//                 const traverse = (node, listType = null, listIndex = 0) => {
//                     if (node.nodeType === 3) {
//                         // Plain text
//                         const tagSet = getAllTags(node.parentElement);
//                         addTextBlock(node.textContent, tagSet, listType, listIndex);
//                     } else if (node.nodeType === 1) {
//                         const tag = node.tagName.toLowerCase();
//                         const isList = tag === 'ul' || tag === 'ol';

//                         if (tag.startsWith('h')) {
//                             // Heading tags
//                             const tagSet = getAllTags(node);
//                             addTextBlock(node.textContent, tagSet, null, null);
//                             return;
//                         }

//                         if (isList) {
//                             const items = node.querySelectorAll(':scope > li');
//                             items.forEach((li, idx) => {
//                                 // Recursively parse children of each <li>
//                                 Array.from(li.childNodes).forEach(child => {
//                                     traverse(child, tag, idx);
//                                 });
//                             });
//                             return;
//                         }

//                         if (tag === 'li') {
//                             // Prevent direct <li> (not scoped in parent list)
//                             Array.from(node.childNodes).forEach(child => {
//                                 traverse(child, listType, listIndex);
//                             });
//                             return;
//                         }

//                         if (tag === 'a') {
//                             const tagSet = getAllTags(node);
//                             const href = node.getAttribute('href');
//                             addTextBlock(node.textContent, tagSet, listType, listIndex, href);
//                             return;
//                         }

//                         // Default case
//                         Array.from(node.childNodes).forEach(child => {
//                             traverse(child, listType, listIndex);
//                         });
//                     }
//                 };

//                 Array.from(wrapper.childNodes).forEach(child => traverse(child));
//                 return lines;
//             }





//             async function drawStyledDescriptionOnNinthPage(ninthPage, description, pdfDoc, fonts) {
//                 const baseFontSize = 9;
//                 const x = 303;
//                 let y = 459;
//                 const maxWidth = 220;

//                 const lines = parseHTMLToStyledLines(description, fonts, maxWidth, baseFontSize);

//                 for (const { text, font, fontSize, underline, color, link } of lines) {
//                     ninthPage.drawText(text, {
//                         x,
//                         y,
//                         size: fontSize,
//                         font,
//                         color,
//                     });

//                     const textWidth = font.widthOfTextAtSize(text, fontSize);

//                     if (underline) {
//                         ninthPage.drawLine({
//                             start: { x, y: y - 1 },
//                             end: { x: x + textWidth, y: y - 1 },
//                             thickness: 0.5,
//                             color,
//                         });
//                     }

//                     if (link) {
//                         const linkAnnotation = pdfDoc.context.obj({
//                             Type: 'Annot',
//                             Subtype: 'Link',
//                             Rect: [x, y, x + textWidth, y + fontSize],
//                             Border: [0, 0, 0],
//                             A: pdfDoc.context.obj({
//                                 Type: 'Action',
//                                 S: 'URI',
//                                 URI: pdfDoc.context.obj(link),
//                             }),
//                         });

//                         const existingAnnots = ninthPage.node.Annots();
//                         if (existingAnnots) {
//                             existingAnnots.push(linkAnnotation);
//                         } else {
//                             ninthPage.node.set(
//                                 'Annots',
//                                 pdfDoc.context.obj([linkAnnotation])
//                             );
//                         }
//                     }


//                     y -= fontSize + 3;
//                 }
//             }





//             // fouteen page
//             const startX = 44;
//             let currentY = 716;
//             const rowHeight = 25;
//             const boldFontSize = 10;
//             const columnWidths = [80, 236, 199];
//             const tableWidth = columnWidths.reduce((a, b) => a + b, 0);

//             // === Header Row ===
//             fouteenPage.drawText('Module Code', {
//                 x: 56,
//                 y: currentY - 7,
//                 size: boldFontSize,
//                 font: fontBold,
//                 color: rgb(0, 0, 0)
//             });
//             fouteenPage.drawText('Module Title', {
//                 x: 110 + columnWidths[0],
//                 y: currentY - 7,
//                 size: boldFontSize,
//                 font: fontBold,
//                 color: rgb(0, 0, 0)
//             });
//             fouteenPage.drawText('Schedule', {
//                 x: 99 + columnWidths[0] + columnWidths[1],
//                 y: currentY - 7,
//                 size: boldFontSize,
//                 font: fontBold,
//                 color: rgb(0, 0, 0)
//             });

//             currentY -= rowHeight;

//             function drawWrappedtText(text, x, y, font, size, maxWidth, lineHeight = 10) {
//                 const words = text.split(' ');
//                 let line = '';
//                 const lines = [];

//                 for (let word of words) {
//                     const testLine = line + word + ' ';
//                     const width = font.widthOfTextAtSize(testLine, size);
//                     if (width > maxWidth && line.length > 0) {
//                         lines.push(line.trim());
//                         line = word + ' ';
//                     } else {
//                         line = testLine;
//                     }
//                 }
//                 if (line.length > 0) lines.push(line.trim());

//                 lines.slice(0, 2).forEach((l, i) => {
//                     fouteenPage.drawText(l, {
//                         x,
//                         y: y - i * lineHeight,
//                         size,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 });
//             }

//             const scheduleDates = studentdetails.scheduleDate || [];
//             const moduleList = studentdetails.batch?.moduleDetails || [];

//             for (let i = 0; i < 12; i++) {
//                 const schedule = scheduleDates[i];
//                 if (!schedule) break;

//                 const moduleCode = `${String(schedule.startModulus)}`;
//                 const matchedModule = moduleList.find(m => m.id === schedule.startModulus);
//                 const moduleTitle = matchedModule?.moduleName || '--';
//                 const scheduleText = `${formatDatepassport(schedule.startDate)} – ${formatDatepassport(schedule.endDate)}`;

//                 fouteenPage.drawText(moduleCode, {
//                     x: startX + 7,
//                     y: currentY - 4,
//                     size: fontSize,
//                     font: fontBold,
//                     color: rgb(0, 0, 0)
//                 });

//                 drawWrappedtText(
//                     moduleTitle,
//                     startX + columnWidths[0] + 5,
//                     currentY - 4,
//                     font,
//                     fontSize,
//                     columnWidths[1] - 10
//                 );

//                 fouteenPage.drawText(scheduleText, {
//                     x: startX + columnWidths[0] + columnWidths[1] + 8,
//                     y: currentY - 4,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0)
//                 });

//                 currentY -= rowHeight;
//             }

//             let borderY = 720 + 5;
//             const totalRows = scheduleDates.length + 1;

//             for (let i = 0; i <= totalRows; i++) {
//                 fouteenPage.drawLine({
//                     start: { x: startX, y: borderY },
//                     end: { x: startX + tableWidth, y: borderY },
//                     thickness: 0.6,
//                     color: rgb(0, 0, 0)
//                 });
//                 borderY -= rowHeight;
//             }

//             let x = startX;
//             for (let j = 0; j < columnWidths.length; j++) {
//                 fouteenPage.drawLine({
//                     start: { x, y: 720 + 5 },
//                     end: { x, y: 720 + 5 - rowHeight * totalRows },
//                     thickness: 0.6,
//                     color: rgb(0, 0, 0),
//                 });
//                 x += columnWidths[j];
//             }

//             fouteenPage.drawLine({
//                 start: { x, y: 720 + 5 },
//                 end: { x, y: 720 + 5 - rowHeight * totalRows },
//                 thickness: 0.6,
//                 color: rgb(0, 0, 0),
//             });

//             // Last page
//             lastPage.drawText(studentName, { x: 156, y: 529, size: 10, font, color: rgb(0, 0, 0), });
//             lastPage.drawText(formatDatepassport(signDate), { x: 73, y: 626, size: 10, font, color: rgb(0, 0, 0), });
//             lastPage.drawText(formatDatepassport(signDate), { x: 73, y: 512, size: 10, font, color: rgb(0, 0, 0), });

//             // fivteenPage



//             fivteenPage.drawText(`${studentdetails?.installmentDue?.length || 0}`, { x: 356, y: 576, size: 10, font, color: rgb(0, 0, 0) });
//             fivteenPage.drawText(`${courseFee.toFixed(2)}`, { x: 360, y: 599, size: 8, font, color: rgb(0, 0, 0), });
//             fivteenPage.drawText(`${courseFee.toFixed(2)}`, { x: 360, y: 683, size: 8, font, color: rgb(0, 0, 0), });
//             const installmentDue = studentdetails?.installmentDue || [];
//             const totalAmount = installmentDue.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);

//             // Table constants
//             let CurrentY = 491;
//             const RowHeight = 21;
//             const col1X = 43.5;
//             const col2X = 235;
//             const col3X = 423;
//             const col4X = 559;
           

//             // Format function
//             function formatInstallmentNumber(num) {
//                 const suffixes = ["th", "st", "nd", "rd"];
//                 const v = num % 100;
//                 const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
//                 return `${num}${suffix} Installment`;
//             }

//             // Loop through installments
//             installmentDue.forEach((item) => {
//                 const { installmentNo, amount, dateDue } = item;

//                 fivteenPage.drawText(formatInstallmentNumber(installmentNo), {
//                     x: col1X + 5,
//                     y: CurrentY,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 fivteenPage.drawText(`$ ${amount.toFixed(2)}`, {
//                     x: col2X + 5,
//                     y: CurrentY,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 fivteenPage.drawText(formatDatepassport(dateDue), {
//                     x: col3X + 5,
//                     y: CurrentY,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 // Borders for each row
//                 fivteenPage.drawLine({ start: { x: col1X, y: CurrentY + RowHeight - 3 }, end: { x: col4X, y: CurrentY + RowHeight - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//                 fivteenPage.drawLine({ start: { x: col1X, y: CurrentY - 3 }, end: { x: col4X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//                 fivteenPage.drawLine({ start: { x: col1X, y: CurrentY + RowHeight - 3 }, end: { x: col1X, y: CurrentY - 3 }, thickness: 0.2, color: rgb(0, 0, 0) });
//                 fivteenPage.drawLine({ start: { x: col2X, y: CurrentY + RowHeight - 3 }, end: { x: col2X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//                 fivteenPage.drawLine({ start: { x: col3X, y: CurrentY + RowHeight - 3 }, end: { x: col3X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//                 fivteenPage.drawLine({ start: { x: col4X, y: CurrentY + RowHeight - 3 }, end: { x: col4X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });

//                 CurrentY -= RowHeight;
//             });

//             // Draw TOTAL row
//             fivteenPage.drawText("Total Amount", {
//                 x: col1X + 5,
//                 y: CurrentY,
//                 size: fontSize,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });
//             fivteenPage.drawText(`$ ${totalAmount.toFixed(2)}`, {
//                 x: col2X + 5,
//                 y: CurrentY,
//                 size: fontSize,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             // Borders for total row
//             fivteenPage.drawLine({ start: { x: col1X, y: CurrentY + RowHeight - 3 }, end: { x: col4X, y: CurrentY + RowHeight - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//             fivteenPage.drawLine({ start: { x: col1X, y: CurrentY - 3 }, end: { x: col4X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//             fivteenPage.drawLine({ start: { x: col1X, y: CurrentY + RowHeight - 3 }, end: { x: col1X, y: CurrentY - 3 }, thickness: 0.2, color: rgb(0, 0, 0) });
//             fivteenPage.drawLine({ start: { x: col2X, y: CurrentY + RowHeight - 3 }, end: { x: col2X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//             fivteenPage.drawLine({ start: { x: col3X, y: CurrentY + RowHeight - 3 }, end: { x: col3X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });
//             fivteenPage.drawLine({ start: { x: col4X, y: CurrentY + RowHeight - 3 }, end: { x: col4X, y: CurrentY - 3 }, thickness: 0.8, color: rgb(0, 0, 0) });

//             // ✅ Draw disclaimer text dynamically below total row
//             const disclaimerStartY = CurrentY - 24; // Below total row

//             const lineY = disclaimerStartY; // Example: let disclaimerStartY = CurrentY - 25;
//             const fulllText = '1. Each instalment amount shall not exceed the following:';
//             const beforeText = '1. Each instalment amount ';
//             const underlinedText = 'shall not exceed';

//             // Draw the full sentence
//             fivteenPage.drawText(fulllText, {
//                 x: col1X,
//                 y: lineY,
//                 size: 9,
//                 font,
//                 color: rgb(0, 0, 0)
//             });

//             // Calculate underline position
//             const starX = col1X + font.widthOfTextAtSize(beforeText, 9);
//             const underlineWidth = font.widthOfTextAtSize(underlinedText, 9);

//             // Draw the underline below "shall not exceed"
//             fivteenPage.drawLine({
//                 start: { x: starX, y: lineY - 2 },  // Slightly below text
//                 end: { x: starX + underlineWidth, y: lineY - 2 },
//                 thickness: 0.5,
//                 color: rgb(0, 0, 0)
//             });


//             fivteenPage.drawText(
//                 '• 2 months’ worth of Course fees for non-EduTrust-certified PEIs without IWC*.',
//                 { x: col1X + 3, y: disclaimerStartY - 12, size: 9, font, color: rgb(0, 0, 0) }
//             );

//             fivteenPage.drawText(
//                 '*Delete as appropriate by striking through this',
//                 { x: col1X + 5, y: disclaimerStartY - 24, size: 6, font, color: rgb(0, 0, 0) }
//             );

//             fivteenPage.drawText(
//                 '2. Each instalment after the first shall be collected within one week before the next payment scheduled.',
//                 { x: col1X, y: disclaimerStartY - 36, size: 9, font, color: rgb(0, 0, 0) }
//             );





//             //  🏫 Draw wrapped institution
//             const wrapText = (text, maxWidth) => {
//                 const words = text.split(" ");
//                 let lines = [];
//                 let currentLine = words[0] || '';

//                 for (let i = 1; i < words.length; i++) {
//                     const word = words[i];
//                     const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);
//                     if (width < maxWidth) {
//                         currentLine += ` ${word}`;
//                     } else {
//                         lines.push(currentLine);
//                         currentLine = word;
//                     }
//                 }

//                 if (currentLine) lines.push(currentLine);
//                 return lines;
//             };

//             const baseY = secondPage.getHeight() - 201;
//             const lineheight = fontSize;
//             const rowSpacing = 27;

//             const institutionXPositions = {
//                 institution: 54,
//                 fromYear: 274,
//                 toYear: 325,
//                 language: 180,
//                 country: 380,
//                 qualificationsAchieved: 450
//             };


//             const highestInstitution = institutionDetails.find(detail => detail.highest);

//             if (highestInstitution) {
//                 const {
//                     institution,
//                     fromYear,
//                     toYear,
//                     language,
//                     country,
//                     qualificationsAchieved,
//                 } = highestInstitution;

//                 const institutionText = String(institution || '').toUpperCase();
//                 const qualificationText = String(qualificationsAchieved || '').toUpperCase();

//                 const institutionLines = wrapText(institutionText, 100);
//                 const qualificationLines = wrapText(qualificationText, 100);

//                 const y = baseY; // Only one row since it's the highest

//                 institutionLines.forEach((line, lineIndex) => {
//                     secondPage.drawText(line, {
//                         x: institutionXPositions.institution,
//                         y: y - lineIndex * lineheight,
//                         size: fontSize,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 });

//                 qualificationLines.forEach((line, lineIndex) => {
//                     secondPage.drawText(line, {
//                         x: institutionXPositions.qualificationsAchieved,
//                         y: y - lineIndex * lineheight,
//                         size: fontSize,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 });

//                 // Single-line fields
//                 secondPage.drawText(String(fromYear || ''), {
//                     x: institutionXPositions.fromYear,
//                     y,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 secondPage.drawText(String(toYear || ''), {
//                     x: institutionXPositions.toYear,
//                     y,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 secondPage.drawText(String(language || '').toUpperCase(), {
//                     x: institutionXPositions.language,
//                     y,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 secondPage.drawText(String(country || '').toUpperCase(), {
//                     x: institutionXPositions.country,
//                     y,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });
//             }



//             // wrap workExperience 

//             function wrapttext(text, font, size, maxWidth) {
//                 const words = text.split(' ');
//                 const lines = [];
//                 let currentLine = '';

//                 for (const word of words) {
//                     const testLine = currentLine ? currentLine + ' ' + word : word;
//                     const testWidth = font.widthOfTextAtSize(testLine, size);

//                     if (testWidth <= maxWidth) {
//                         currentLine = testLine;
//                     } else {
//                         if (currentLine) lines.push(currentLine);
//                         currentLine = word;
//                     }
//                 }

//                 if (currentLine) lines.push(currentLine);
//                 return lines;
//             }

//             const workExperienceInitialY = secondPage.getHeight() - 307;
//             const workExperienceRowSpacing = 28;
//             const lineHeight = 14;

//             const workExperienceXPositions = {
//                 country: 420,
//                 fromYear: 280,
//                 toYear: 360,
//                 name: 60,
//                 natureOfPosition: 470,
//                 position: 165,
//             };

//             let yCursor = workExperienceInitialY;

//             workExpirences.forEach((exp) => {
//                 const {
//                     country,
//                     fromYear,
//                     toYear,
//                     name,
//                     natureOfPosition,
//                     position,
//                 } = exp;

//                 const countryText = String(country || '').toUpperCase();
//                 const fromYearText = String(fromYear || '');
//                 const toYearText = String(toYear || '');
//                 const nameText = String(name || '').toUpperCase();
//                 const natureOfPositionText = String(natureOfPosition || '').toUpperCase();
//                 const positionText = String(position || '').toUpperCase();

//                 const nameLines = wrapttext(nameText, font, fontSize, 115);
//                 const positionLines = wrapttext(positionText, font, fontSize, 59);
//                 const natureLines = wrapttext(natureOfPositionText, font, fontSize, 110);

//                 const maxLines = Math.max(nameLines.length, positionLines.length, natureLines.length);

//                 // Draw static fields
//                 secondPage.drawText(countryText, {
//                     x: workExperienceXPositions.country,
//                     y: yCursor,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 secondPage.drawText(fromYearText, {
//                     x: workExperienceXPositions.fromYear,
//                     y: yCursor,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 secondPage.drawText(toYearText, {
//                     x: workExperienceXPositions.toYear,
//                     y: yCursor,
//                     size: fontSize,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });

//                 // Draw wrapped natureOfPosition
//                 natureLines.forEach((line, idx) => {
//                     secondPage.drawText(line, {
//                         x: workExperienceXPositions.natureOfPosition,
//                         y: yCursor - idx * lineHeight,
//                         size: fontSize,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 });

//                 // Draw wrapped name
//                 nameLines.forEach((line, index) => {
//                     secondPage.drawText(line, {
//                         x: workExperienceXPositions.name,
//                         y: yCursor - index * lineHeight,
//                         size: fontSize,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 });

//                 // Draw wrapped position
//                 positionLines.forEach((line, index) => {
//                     secondPage.drawText(line, {
//                         x: workExperienceXPositions.position,
//                         y: yCursor - index * lineHeight,
//                         size: fontSize,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 });

//                 // Move to next row based on the tallest block
//                 yCursor -= workExperienceRowSpacing + (maxLines - 1) * lineHeight;
//             });



//             // Load and embed the tick icon image
//             const tickIconBytes = await fetch(icon).then(res => res.arrayBuffer());
//             const tickIconImage = await pdfDoc.embedPng(tickIconBytes);

//             // Define scaling factors
//             const scaleFirstPage = 0.02; // Scale for the existing tick icons on the first page
//             const scaleSixthPage = 0.012; // Scale for the sixth page
//             const scaleSeventhPage = 0.014; // Scale for the seventh page
//             const separateScaleFirstPage = 0.02; // Scale for the top-right corner tick icon

//             // Set scaling factors

//             const separateScaledIconFirstPage = tickIconImage.scale(separateScaleFirstPage);

//             const { width: separateWidthFirstPage, height: separateHeightFirstPage } = separateScaledIconFirstPage;
//             const fonts = {
//                 fonte: font,
//                 fontBold: fontBold,
//                 fontitalics: fontitalic,
//                 fontitalicBolds: fontitalicBold,
//             };

//             await drawStyledDescriptionOnNinthPage(ninthPage, studentdetails?.batch?.description || '', pdfDoc, fonts);
//             // Save the modified PDF
//             const pdfBytesModified = await pdfDoc.save();
//             const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
//             const pdfUrl = URL.createObjectURL(pdfBlob);
//             window.open(pdfUrl, '_blank');
//         } catch (error) {
//             console.error('Error generating PDF:', error);
//             toast.error(error?.message || 'Something went wrong while generating the PDF');
//         }
//     };


//     const extractDate = (dateStr) => {
//         const date = new Date(dateStr);
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//         const day = String(date.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     };

//     const toUpperCaseString11 = (dateString) => {
//         const date = new Date(dateString);
//         const month = getMonthName(date.getMonth());
//         const year = date.getFullYear();
//         return `${month} ${year}`;
//     };

//     const getMonthName = (monthNumber) => {
//         const monthNames = [
//             "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
//             "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
//         ];
//         return monthNames[monthNumber];
//     };


//     function removeFirstTwoNumbersAfterDash(input) {
//         // Split the input string into two parts at the first '-'
//         const [prefix, suffix] = input.split('-');

//         // Remove the first two numbers from the suffix
//         const modifiedSuffix = suffix.replace(/^\d{2}/, '');

//         // Recombine the prefix and modified suffix
//         return `${prefix}-${modifiedSuffix}`;
//     }

//     // Example usage
//     const result = removeFirstTwoNumbersAfterDash('DCE-241');
//     console.log(result);  // Output: 'DCE-1'



//     useImperativeHandle(ref, () => ({ handleDownload }));

//     return null;
// });

// export default ApplicationForm;



import React, { forwardRef, useImperativeHandle } from 'react';
import Application from '../pdf/Application.pdf'
import { PDFDocument, rgb } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
import fontkit from '@pdf-lib/fontkit';
import TimesRoman from '../fonts/times.ttf'
import TimesRomanBold from '../fonts/TimesBold.ttf'
import TimesRomanItalic from '../fonts/FontsFree-Net-times-new-roman-italic.ttf'
import TimesRomanitalicBold from '../fonts/Times-New-Romance-Bold-Italic.ttf'
import { toast } from 'react-toastify';
import { removeBracketedText } from '../Axiosinstance';

const ApplicationForm = forwardRef((dataProp, ref) => {

    // ─── Safe date formatter ─────────────────────────────────────────────────
    function formatDatepassport(dateString) {
        if (!dateString) return '';
        const parts = dateString.split('-');
        if (parts.length !== 3) return '';
        const [year, month, day] = parts;
        const date = new Date(`${year}-${month}-${day}`);
        if (isNaN(date.getTime())) return '';
        const dayStr   = String(date.getDate()).padStart(2, '0');
        const monthStr = date.toLocaleString('en-US', { month: 'long' });
        const yearStr  = date.getFullYear();
        return `${dayStr} ${monthStr} ${yearStr}`;
    }

    // ─── Word-wrap helper ────────────────────────────────────────────────────
    function wrapText(text, f, size, maxWidth) {
        const words = text.split(' ');
        const lines = [];
        let currentLine = '';
        for (const word of words) {
            const testLine = currentLine ? currentLine + ' ' + word : word;
            if (f.widthOfTextAtSize(testLine, size) <= maxWidth) {
                currentLine = testLine;
            } else {
                if (currentLine) lines.push(currentLine);
                currentLine = word;
            }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
    }

    const handleDownload = async (studentdetails) => {
        console.log('studentdetails', studentdetails);
        try {
            // ── Load PDF ─────────────────────────────────────────────────────
            const pdfBytes = await fetch(Application).then(res => {
                if (!res.ok) throw new Error(`Failed to fetch PDF: ${res.status}`);
                return res.arrayBuffer();
            });
            const pdfDoc = await PDFDocument.load(pdfBytes);
            pdfDoc.registerFontkit(fontkit);

            // ── Page count guard ─────────────────────────────────────────────
            const pages = pdfDoc.getPages();
            console.log('PDF page count:', pages.length);
            if (pages.length < 2) {
                toast.error(`PDF has only ${pages.length} page(s) — expected 2.`);
                return;
            }

            const firstPage  = pages[0];
            const secondPage = pages[1];

            // ── Embed fonts ──────────────────────────────────────────────────
            const font         = await pdfDoc.embedFont(await fetch(TimesRoman).then(r => r.arrayBuffer()));
            const fontBold     = await pdfDoc.embedFont(await fetch(TimesRomanBold).then(r => r.arrayBuffer()));
            const fontItalic   = await pdfDoc.embedFont(await fetch(TimesRomanItalic).then(r => r.arrayBuffer()));
            const fontItBold   = await pdfDoc.embedFont(await fetch(TimesRomanitalicBold).then(r => r.arrayBuffer()));

            const fontSize = 9;

            // ── Student data ─────────────────────────────────────────────────
            const studentName        = (studentdetails?.name               || '').toUpperCase();
            const passportNo         =  studentdetails?.passport            || '';
            const passportExpire     =  studentdetails?.passportExpiryDate  || '';
            const nric               =  studentdetails?.nric                || '';
            const handphone          =  studentdetails?.phone               || '';
            const officephone        =  studentdetails?.officephone         || '';
            const email              =  studentdetails?.email               || '';
            const dob                =  studentdetails?.dob                 || '';
            const citizenship        = (studentdetails?.citizenship         || '').toUpperCase();
            const maritalStatus      = (studentdetails?.maritalStatus       || '').toUpperCase();
            const religion           = (studentdetails?.religion            || '').toUpperCase();
            const gender             = (studentdetails?.gender              || '').toUpperCase();
            const postalcode         =  studentdetails?.postalcode          || '';
            const courseFee          =  Number(studentdetails?.batch?.courseFee) || 0;
            const duration           =  studentdetails?.batch?.duration     || 0;
            const courseType         =  studentdetails?.batch?.courseType   || '';
            const emergencyContacts  =  studentdetails?.emergencyContacts   || [];
            const signDate           =  studentdetails?.signDate            || '';
            const address            = (studentdetails?.address             || '').toUpperCase();
            const currentAddress     = (studentdetails?.currentAddress      || '').toUpperCase();
            const workExpirences     =  studentdetails?.workExpirences      || [];
            const institutionDetails =  studentdetails?.institutionDetails  || [];
            const course             =  removeBracketedText(studentdetails?.course || '').toUpperCase();

            // ── Embed profile image (optional, won't crash if missing) ───────
            let image;
            const imageUrl = studentdetails?.profileUrl || '';
            if (imageUrl) {
                try {
                    const imageBytes = await fetch(imageUrl).then(r => r.arrayBuffer());
                    const lower      = imageUrl.toLowerCase();
                    if (lower.endsWith('.png'))                              image = await pdfDoc.embedPng(imageBytes);
                    else if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) image = await pdfDoc.embedJpg(imageBytes);
                    else console.warn('Unsupported image format — skipping.');
                } catch (imgErr) {
                    console.warn('Could not load profile image:', imgErr);
                }
            }
            if (image) {
                firstPage.drawImage(image, { x: 438, y: 561, width: 118, height: 130 });
            }

            // ════════════════════════════════════════════════════════════════
            // PAGE 1  — Personal / Course / Address / Emergency contacts
            // ════════════════════════════════════════════════════════════════

            // Personal info
            firstPage.drawText(studentName,                        { x: 185, y: 487, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(passportNo,                         { x: 175, y: 468, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(formatDatepassport(passportExpire), { x: 440, y: 468, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(nric,                               { x: 188, y: 449, size: 11, font, color: rgb(0,0,0) });
            firstPage.drawText(formatDatepassport(dob),            { x: 440, y: 446, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(religion,                           { x: 189, y: 404, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(handphone,                          { x: 190, y: 384, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(officephone,                        { x: 439, y: 384, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(email,                              { x: 185, y: 360, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(citizenship,                        { x: 439, y: 404, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(gender,                             { x: 189, y: 427, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(maritalStatus,                      { x: 439, y: 426, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(postalcode,                         { x: 204, y: 318, size: 12, font, color: rgb(0,0,0) });

            // Course info
            firstPage.drawText(`${courseFee} $`,   { x: 322, y: 576, size: 12, font, color: rgb(0,0,0) });
            firstPage.drawText(`${duration} Months`, { x: 174, y: 576, size: 12, font, color: rgb(0,0,0) });

            // Course name — word-wrapped
            let courseY = 605;
            wrapText(course, font, 12, 260).forEach(line => {
                firstPage.drawText(line, { x: 175, y: courseY, size: 12, font, color: rgb(0,0,0) });
                courseY -= 12;
            });

            // Course type strikethrough
            if (courseType !== 'Full time') {
                firstPage.drawLine({ start: { x: 164, y: 552 }, end: { x: 212, y: 552 }, thickness: 1, color: rgb(0,0,0) });
            }
            if (courseType !== 'Part time') {
                firstPage.drawLine({ start: { x: 221, y: 552 }, end: { x: 267, y: 552 }, thickness: 1, color: rgb(0,0,0) });
            }

            // Home address — word-wrapped
            wrapText(address, font, 11, 300).forEach((line, i) => {
                firstPage.drawText(line, { x: 187, y: 337 - i * 13, size: 11, font, color: rgb(0,0,0) });
            });

            // Singapore address — word-wrapped
            wrapText(currentAddress, font, 11, 300).forEach((line, i) => {
                firstPage.drawText(line, { x: 190, y: 249 - i * 13, size: 11, font, color: rgb(0,0,0) });
            });

            // Emergency contacts — collect used relationships
            const usedLabels = new Set();
            emergencyContacts.forEach(c => {
                const rel = c.relationship?.toLowerCase();
                if (rel === 'others') usedLabels.add('othersname');
                else if (rel) usedLabels.add(rel);
            });

            emergencyContacts.forEach(({ name = '', number = '', relationship = '', othersRelationship = '' }) => {
                const fs = 12;
                if (relationship === 'Brother' || relationship === 'Sister') {
                    firstPage.drawText(name,   { x: 179, y: 232, size: fs, font, color: rgb(0,0,0) });
                    firstPage.drawText(number, { x: 419, y: 232, size: fs, font, color: rgb(0,0,0) });
                } else if (relationship === 'Mother') {
                    firstPage.drawText(name,   { x: 179, y: 251, size: fs, font, color: rgb(0,0,0) });
                    firstPage.drawText(number, { x: 419, y: 251, size: fs, font, color: rgb(0,0,0) });
                } else if (relationship === 'Father') {
                    firstPage.drawText(name,   { x: 179, y: 252, size: fs, font, color: rgb(0,0,0) });
                    firstPage.drawText(number, { x: 419, y: 252, size: fs, font, color: rgb(0,0,0) });
                } else if (relationship === 'Others') {
                    firstPage.drawText(name,              { x: 180, y: 212, size: fs, font, color: rgb(0,0,0) });
                    firstPage.drawText(number,            { x: 420, y: 212, size: fs, font, color: rgb(0,0,0) });
                    firstPage.drawText(othersRelationship,{ x: 300, y: 196, size: fs, font, color: rgb(0,0,0) });
                }
            });

            // Strike through unused emergency labels
            const strikeLbl = (label, x, y) => {
                const w = font.widthOfTextAtSize(label, fontSize);
                firstPage.drawLine({ start: { x, y: y + 6 }, end: { x: x + w, y: y + 6 }, thickness: 1, color: rgb(0,0,0) });
            };
            [
                { label: 'brother',    x: 58, y: 233 },
                { label: 'sister',     x: 92, y: 233 },
                { label: 'mother',     x: 93, y: 254 },
                { label: 'father',     x: 56, y: 254 },
                { label: 'othersname', x: 57, y: 213 },
            ].forEach(({ label, x, y }) => {
                if (!usedLabels.has(label)) {
                    strikeLbl(label.charAt(0).toUpperCase() + label.slice(1), x, y);
                }
            });

            // ════════════════════════════════════════════════════════════════
            // PAGE 2  — Declaration + Education + Work Experience + Sign date
            // ════════════════════════════════════════════════════════════════

            // Declaration paragraph — justified, student name underlined on first line
            const declarationText = `I, ${studentName} declare that all information given by me in this registration form are true and correct and I understand that any misinterpretation or omission of information is sufficient grounds for rejecting my application. I also authorize any investigation of the above information for the purpose of verification. While I am a Student, I undertake to observe all the statues, By-Laws and Rules of the School. I agree to pay the full course fees for one year.`;

            const maxWith   = 480;
            const lineHeigh = 12;
            const xStart    = 53;
            let   declY     = 345;

            // Build justified lines
            const declLines = [];
            let   declLine  = '';
            declarationText.split(' ').forEach(word => {
                const test = declLine ? `${declLine} ${word}` : word;
                if (font.widthOfTextAtSize(test, fontSize) > maxWith) {
                    declLines.push(declLine);
                    declLine = word;
                } else {
                    declLine = test;
                }
            });
            if (declLine) declLines.push(declLine);

            declLines.forEach((line, idx) => {
                const isLast   = idx === declLines.length - 1;
                const words    = line.trim().split(' ');
                const currentY = declY - idx * lineHeigh;

                if (isLast || words.length === 1) {
                    secondPage.drawText(line, { x: xStart, y: currentY, size: fontSize, font, color: rgb(0,0,0) });
                } else {
                    // Justify the line
                    const totalTxtW  = font.widthOfTextAtSize(words.join(''), fontSize);
                    const spaceWidth = (maxWith - totalTxtW) / (words.length - 1);
                    let   currentX   = xStart;

                    // Underline student name on the first line
                    if (idx === 0) {
                        const fullLine = words.join(' ');
                        if (fullLine.includes(studentName)) {
                            const before     = fullLine.slice(0, fullLine.indexOf(studentName));
                            const underlineX = xStart + font.widthOfTextAtSize(before, fontSize);
                            const underlineW = font.widthOfTextAtSize(studentName, fontSize);
                            secondPage.drawLine({
                                start: { x: underlineX, y: currentY - 1 },
                                end:   { x: underlineX + underlineW, y: currentY - 1 },
                                thickness: 0.5, color: rgb(0,0,0),
                            });
                        }
                    }

                    words.forEach((word, i) => {
                        secondPage.drawText(word, { x: currentX, y: currentY, size: fontSize, font, color: rgb(0,0,0) });
                        currentX += font.widthOfTextAtSize(word, fontSize);
                        if (i < words.length - 1) currentX += spaceWidth;
                    });
                }
            });

            // Sign dates on page 2
            secondPage.drawText(formatDatepassport(signDate), { x: 460, y: 268, size: 9, font, color: rgb(0,0,0) });
            secondPage.drawText(formatDatepassport(signDate), { x: 494, y: 96,  size: 9, font, color: rgb(0,0,0) });

            // ── Highest institution ──────────────────────────────────────────
            const { height: page2Height } = secondPage.getSize();   // ✅ correct API
            const baseY      = page2Height - 201;
            const lineheight = fontSize;

            const instXPos = {
                institution: 54, fromYear: 274, toYear: 325,
                language: 180, country: 380, qualificationsAchieved: 450,
            };

            const highestInst = institutionDetails.find(d => d.highest);
            if (highestInst) {
                const {
                    institution = '', fromYear = '', toYear = '',
                    language = '', country = '', qualificationsAchieved = '',
                } = highestInst;

                wrapText(String(institution).toUpperCase(), font, fontSize, 100).forEach((l, i) => {
                    secondPage.drawText(l, { x: instXPos.institution, y: baseY - i * lineheight, size: fontSize, font, color: rgb(0,0,0) });
                });
                wrapText(String(qualificationsAchieved).toUpperCase(), font, fontSize, 100).forEach((l, i) => {
                    secondPage.drawText(l, { x: instXPos.qualificationsAchieved, y: baseY - i * lineheight, size: fontSize, font, color: rgb(0,0,0) });
                });
                secondPage.drawText(String(fromYear), { x: instXPos.fromYear, y: baseY, size: fontSize, font, color: rgb(0,0,0) });
                secondPage.drawText(String(toYear),   { x: instXPos.toYear,   y: baseY, size: fontSize, font, color: rgb(0,0,0) });
                secondPage.drawText(String(language).toUpperCase(), { x: instXPos.language, y: baseY, size: fontSize, font, color: rgb(0,0,0) });
                secondPage.drawText(String(country).toUpperCase(),  { x: instXPos.country,  y: baseY, size: fontSize, font, color: rgb(0,0,0) });
            }

            // ── Work experience ──────────────────────────────────────────────
            let yCursor         = page2Height - 307;
            const workRowSpacing = 28;
            const workLineH     = 14;
            const workXPos = {
                name: 60, position: 165, fromYear: 280,
                toYear: 360, country: 420, natureOfPosition: 470,
            };

            workExpirences.forEach(exp => {
                const nameT   = String(exp.name             || '').toUpperCase();
                const posT    = String(exp.position         || '').toUpperCase();
                const natureT = String(exp.natureOfPosition || '').toUpperCase();
                const countryT = String(exp.country         || '').toUpperCase();
                const fromT   = String(exp.fromYear         || '');
                const toT     = String(exp.toYear           || '');

                const nameLns   = wrapText(nameT,   font, fontSize, 115);
                const posLns    = wrapText(posT,    font, fontSize, 59);
                const natureLns = wrapText(natureT, font, fontSize, 110);
                const maxLns    = Math.max(nameLns.length, posLns.length, natureLns.length);

                secondPage.drawText(countryT, { x: workXPos.country,  y: yCursor, size: fontSize, font, color: rgb(0,0,0) });
                secondPage.drawText(fromT,    { x: workXPos.fromYear, y: yCursor, size: fontSize, font, color: rgb(0,0,0) });
                secondPage.drawText(toT,      { x: workXPos.toYear,   y: yCursor, size: fontSize, font, color: rgb(0,0,0) });
                nameLns.forEach((l, i)   => secondPage.drawText(l, { x: workXPos.name,             y: yCursor - i * workLineH, size: fontSize, font, color: rgb(0,0,0) }));
                posLns.forEach((l, i)    => secondPage.drawText(l, { x: workXPos.position,         y: yCursor - i * workLineH, size: fontSize, font, color: rgb(0,0,0) }));
                natureLns.forEach((l, i) => secondPage.drawText(l, { x: workXPos.natureOfPosition, y: yCursor - i * workLineH, size: fontSize, font, color: rgb(0,0,0) }));

                yCursor -= workRowSpacing + (maxLns - 1) * workLineH;
            });

            // ── Save and open ────────────────────────────────────────────────
            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            window.open(URL.createObjectURL(pdfBlob), '_blank');

        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error(error?.message || 'Something went wrong while generating the PDF');
        }
    };

    useImperativeHandle(ref, () => ({ handleDownload }));
    return null;
});

export default ApplicationForm;